import React from "react";
import ReactDOM from 'react-dom';
import { Field, reduxForm, Fields } from "redux-form";
import { Form, FormGroup, Label, Alert } from "reactstrap";

import TextInput from "../../system/fields/TextInput";
import SelectDropdown from "../../system/fields/SelectDropdown";
import FileUpload from "../../system/fields/FileUpload";
import StarRating from "../../system/fields/StarRating";

import * as validations from "../../system/utils/Validation";
import Wysiwyg from "../../system/fields/Wysiwyg";

const renderFields = (fields) => {
  // console.log("FIELDS: ", fields);
  const fieldNames = fields.names;
  // console.log("FIELDNAMES: ", fieldNames);
  return fieldNames.map((field) => {
    const fieldType = field.split('_Type_')[1];
    // console.log("FIELDTYPE: ", fieldType);
    if (fieldType === "TextInput") {
      return (
        <FormGroup className={"col-12 col-md-6"}>
          <Label className={"mt-2"}><b>{field.split('_Type_')[0].replace(/_/g, ' ')}</b></Label>
          <Field
            name={`content.${field}`}
            component={TextInput}
            type={"text"}
          />
        </FormGroup>
      )
    }
    if (fieldType === 'Wysiwyg') {
      return (
        <FormGroup className={"col-12"}>
          <Label className={"mt-2"}><b>{field.split('_Type_')[0].replace(/_/g, ' ')}</b></Label>
          <Field
            name={`content.${field}`}
            component={Wysiwyg}
          />
        </FormGroup>
      )
    }
    if (fieldType === 'FileUpload') {
      return (
        <FormGroup className={"col-12"}>
          <Label className={"mt-2"}><b>{field.split('_Type_')[0].replace(/_/g, ' ')}</b></Label>
          <Field
            name={`content.${field}`}
            component={FileUpload}
          />
        </FormGroup>
      )
    }
    if (fieldType === 'Section') {
      return (
        <section className="col-12">
          <hr style={{ marginTop: 30, marginBottom: 30 }} />
        </section>
      )
    }
    return null;
  });
};

let EditForm = (props, { fields }) => {
  const { handleSubmit, mode, data } = props;
  return (
    <section className="edit-form">
      <Form onSubmit={handleSubmit}>
        <section className="form-section">
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Page Name</Label>
              <Field
                name="name"
                component={TextInput}
                type="text"
                disabled
              />
            </FormGroup>

            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Page URL</Label>
              <Field
                name="url"
                component={TextInput}
                disabled
                type="text"
              />
            </FormGroup>
          </div>
          {data !== null && data !== undefined && data.content !== null && data.content !== undefined &&
            <div className="row">
              <Fields
                names={Object.keys(data.content)}
                component={renderFields}
              />
            </div>
          }
        </section>
      </Form>

      {props.submitFailed && (
        <div className="error-container">
          <Alert color="danger">
            <strong>There are errors in your form.</strong>
            <br />Please check before submitting again.
          </Alert>
        </div>
      )}
    </section>
  );
};

EditForm = reduxForm({
  form: "PagesForm"
})(EditForm);

export default EditForm;



// WEBPACK FOOTER //
// ./src/containers/Pages/Form.jsx